import { resolveRelayerUrl } from "../../relayers/resolve";
import { FeatureFlagKey } from "../../features/types";
import { ChainIdEnum } from "../../../enums/chain";
import { WalletProviderKind } from "../../../enums/walletProvider";
import { ChainConfig } from "../types";
import {
  DOGEOS_BRANDING,
  getPerpetualDexConfig,
  getTokenAddress,
} from "./shared";

// ============================================
// DOGEOS TESTNET (Chain ID: 6281971)
// ============================================
export const dogeosTestnetConfig: ChainConfig = {
  chainId: ChainIdEnum.DOGEOS_TESTNET,
  name: "Dogeos Testnet",
  shortName: "Dogeos",
  isTestnet: true,
  rpcUrls: [
    process.env.REACT_APP_RPC_URL || "https://rpc.testnet.dogeos.com",
  ],
  wsUrl: process.env.REACT_APP_WSS_URL,
  explorerUrl: "https://blockscout.testnet.dogeos.com/",
  l2ExplorerUrl: "https://blockscout.testnet.dogeos.com/",
  nativeCurrency: { name: "DOGE", symbol: "DOGE", decimals: 18 },
  // MWETH is a standalone ERC-20 here (native gas = DOGE), so WETH deposits
  // must read the ERC-20 balance, not the native DOGE balance.
  wethIsErc20Collateral: true,
  tokenDecimals: {
    usdc: parseInt(process.env.REACT_APP_USDC_DECIMALS || "6", 10),
    usdt: 6,
    weth: 18,
    wbtc: 8,
    sdai: 6,
  },
  contracts: {
    erc20: {
      usdc: getTokenAddress(ChainIdEnum.DOGEOS_TESTNET, "USDC", "0x25c2633c90463094321e4c7978b63575e5c675c3"),
      "usdc-native": "",
      usdt: "0xC81800b77D91391Ef03d7868cB81204E753093a9",
      weth: getTokenAddress(ChainIdEnum.DOGEOS_TESTNET, "WETH", "0x524a56284ffa1b6cad00b244e3ce2abc1c45ddd1"),
      wbtc: getTokenAddress(ChainIdEnum.DOGEOS_TESTNET, "WBTC", "0x1ec562961e66d1e2551afbac3fc5dfaef77d882f"),
      l2usdc: "",
      l2usdt: "",
      l2weth: "",
      l2wbtc: "",
      govToken: "",
    },
    bridge: {
      l1DepositHelper: "0x5FC8d32690cc91D4c39d9d3abcBD16989F875707",
      l1StandardBridge: "0x9fE46736679d2D9a65F0992F2272dE9f3c7fa6e0",
      l2StandardBridge: "0xa513E6E4b8f2a923D98304ec87F64353C4D5C853",
      l2WithdrawProxy: "0x9A676e781A523b5d0C0e43731313A708CB607508",
      exchangePass: "",
      strategies: "",
      staking: "",
    },
    // perpetualDex comes from deployments/6281971.json. getPerpetualDexConfig
    // refuses hardcoded fallbacks for the active chain, so only USDC is kept
    // here; the stale pre-redeploy addresses that used to sit here are gone.
    perpetualDex: getPerpetualDexConfig(ChainIdEnum.DOGEOS_TESTNET, {
      router: "",
      crossMargin: "",
      orderHandler: "",
      perpRouter: "",
      orderVault: "",
      marketFactory: "",
      usdc: "0x25c2633c90463094321e4c7978b63575e5c675c3",
      unifiedVault: "",
      unifiedMarginAdapter: "",
      positionHandler: "",
      backstopVault: "",
      oracle: "",
      dataStore: "",
      marketHandler: "",
      markets: {},
    }),
  },
  signingDomain: { name: "MuchFi DogeOS Testnet", version: "1" },
  // Ultrafuzz M-1: DogeOS's CLOBRouter market-order functions gained `maxQuoteIn`. Use the V2
  // signed struct + the 6-param direct call args (see useSpotOrder.place.ts).
  spotMarketMaxQuoteIn: true,
  gasless: true,
  relayerUrl: resolveRelayerUrl(ChainIdEnum.DOGEOS_TESTNET),
  supportsSubaccounts: false,
  supportsTpsl: true,
  walletProvider: WalletProviderKind.DOGEOS,
  // Spot CLOB is deployed here, so the spot vertical is available (it is off by
  // default and opted into per chain). See src/config/features.
  tradingTypes: {
    [FeatureFlagKey.PERPETUAL_SPOT]: true,
  },

  branding: DOGEOS_BRANDING,
};
